<template lang="pug">
  div.container-fluid.background-login.vertical-center.px-0
    div.row.d-flex.justify-content-center
      div.col-12.col-sm-12.col-md-8.col-lg-6
        div.card
          div.submitting-text(v-if="submitting")
            | Informationen werden übermittelt...
          div.card-header
            | Schüler-Registrierung
          div.card-body(:class="{ invisible: submitting }" v-if="!successMessage")
            form(@submit.prevent="submitRegistration")
              // Personal Information
              h5.mb-3 Persönliche Daten

              div.form-group
                label(for="firstName") Vorname *
                input.form-control(
                  type="text"
                  id="firstName"
                  v-model="formData.firstName"
                  :class="{ 'is-invalid': errors.firstName }"
                  required
                )
                div.invalid-feedback(v-if="errors.firstName") {{ errors.firstName }}

              div.form-group
                label(for="lastName") Nachname *
                input.form-control(
                  type="text"
                  id="lastName"
                  v-model="formData.lastName"
                  :class="{ 'is-invalid': errors.lastName }"
                  required
                )
                div.invalid-feedback(v-if="errors.lastName") {{ errors.lastName }}

              div.form-group
                label(for="email") E-Mail Adresse *
                input.form-control(
                  type="email"
                  id="email"
                  v-model="formData.email"
                  :class="{ 'is-invalid': errors.email }"
                  required
                )
                div.invalid-feedback(v-if="errors.email") {{ errors.email }}
                small.form-text.text-muted Sie erhalten eine Bestätigungs-E-Mail an diese Adresse

              div.form-group
                label(for="password") Passwort *
                input.form-control(
                  type="password"
                  id="password"
                  v-model="formData.password"
                  :class="{ 'is-invalid': errors.password }"
                  required
                )
                div.invalid-feedback(v-if="errors.password") {{ errors.password }}
                small.form-text.text-muted Mindestens 8 Zeichen

              div.form-group
                label(for="passwordConfirm") Passwort bestätigen *
                input.form-control(
                  type="password"
                  id="passwordConfirm"
                  v-model="formData.passwordConfirm"
                  :class="{ 'is-invalid': errors.passwordConfirm }"
                  required
                )
                div.invalid-feedback(v-if="errors.passwordConfirm") {{ errors.passwordConfirm }}

              // Billing Address
              h5.mb-3.mt-4 Rechnungsadresse
              div.form-group
                label(for="street") Straße und Hausnummer *
                input.form-control(
                  type="text"
                  id="street"
                  v-model="formData.billingAddress.street"
                  :class="{ 'is-invalid': errors['billingAddress.street'] }"
                  required
                )
                div.invalid-feedback(v-if="errors['billingAddress.street']") {{ errors['billingAddress.street'] }}

              div.form-group
                label(for="zip") Postleitzahl *
                input.form-control(
                  type="text"
                  id="zip"
                  v-model="formData.billingAddress.zip"
                  :class="{ 'is-invalid': errors['billingAddress.zip'] }"
                  required
                )
                div.invalid-feedback(v-if="errors['billingAddress.zip']") {{ errors['billingAddress.zip'] }}

              div.form-group
                label(for="city") Stadt *
                input.form-control(
                  type="text"
                  id="city"
                  v-model="formData.billingAddress.city"
                  :class="{ 'is-invalid': errors['billingAddress.city'] }"
                  required
                )
                div.invalid-feedback(v-if="errors['billingAddress.city']") {{ errors['billingAddress.city'] }}

              div.form-group
                label(for="country") Land *
                select.form-control(
                  id="country"
                  v-model="formData.billingAddress.country"
                  :class="{ 'is-invalid': errors['billingAddress.country'] }"
                  required
                )
                  option(value="DE") Deutschland
                  option(value="AT") Österreich
                div.invalid-feedback(v-if="errors['billingAddress.country']") {{ errors['billingAddress.country'] }}

              // Delivery Address
              div.form-check.mb-3
                input.form-check-input(
                  type="checkbox"
                  id="sameAddress"
                  v-model="sameAsShipping"
                  @change="toggleSameAddress"
                )
                label.form-check-label(for="sameAddress")
                  | Lieferadresse ist gleich Rechnungsadresse

              div(v-if="!sameAsShipping")
                h5.mb-3 Lieferadresse
                div.form-group
                  label(for="deliveryStreet") Straße und Hausnummer *
                  input.form-control(
                    type="text"
                    id="deliveryStreet"
                    v-model="formData.deliveryAddress.street"
                    :class="{ 'is-invalid': errors['deliveryAddress.street'] }"
                    :required="!sameAsShipping"
                  )
                  div.invalid-feedback(v-if="errors['deliveryAddress.street']") {{ errors['deliveryAddress.street'] }}

                div.form-group
                  label(for="deliveryZip") Postleitzahl *
                  input.form-control(
                    type="text"
                    id="deliveryZip"
                    v-model="formData.deliveryAddress.zip"
                    :class="{ 'is-invalid': errors['deliveryAddress.zip'] }"
                    :required="!sameAsShipping"
                  )
                  div.invalid-feedback(v-if="errors['deliveryAddress.zip']") {{ errors['deliveryAddress.zip'] }}

                div.form-group
                  label(for="deliveryCity") Stadt *
                  input.form-control(
                    type="text"
                    id="deliveryCity"
                    v-model="formData.deliveryAddress.city"
                    :class="{ 'is-invalid': errors['deliveryAddress.city'] }"
                    :required="!sameAsShipping"
                  )
                  div.invalid-feedback(v-if="errors['deliveryAddress.city']") {{ errors['deliveryAddress.city'] }}

                div.form-group
                  label(for="deliveryCountry") Land *
                  select.form-control(
                    id="deliveryCountry"
                    v-model="formData.deliveryAddress.country"
                    :class="{ 'is-invalid': errors['deliveryAddress.country'] }"
                    :required="!sameAsShipping"
                  )
                    option(value="DE") Deutschland
                    option(value="AT") Österreich
                  div.invalid-feedback(v-if="errors['deliveryAddress.country']") {{ errors['deliveryAddress.country'] }}

              // Document Upload
              h5.mb-3.mt-4 Schülerausweis
              div.form-group
                label(for="documents") Schülerausweis hochladen *
                div.custom-file
                  input.custom-file-input(
                    type="file"
                    id="documents"
                    multiple
                    accept=".pdf,.jpg,.jpeg,.png"
                    @change="handleFileUpload"
                    :class="{ 'is-invalid': errors.documents }"
                    required
                  )
                  label.custom-file-label(for="documents")
                    | {{ uploadedFiles.length > 0 ? uploadedFiles.length + ' Datei(en) ausgewählt' : 'Dateien auswählen' }}
                small.form-text.text-muted
                  | Max. 5MB pro Datei. Erlaubte Formate: PDF, JPG, PNG
                  br
                  | Sie können mehrere Dateien auswählen
                div.invalid-feedback(v-if="errors.documents") {{ errors.documents }}

                div.mt-2(v-if="uploadedFiles.length > 0")
                  h6 Ausgewählte Dateien:
                  ul.list-unstyled
                    li(v-for="(file, index) in uploadedFiles" :key="index")
                      span.mr-2 📄
                      | {{ file.name }} ({{ formatFileSize(file.size) }})
                      button.btn.btn-sm.btn-link.text-danger(
                        type="button"
                        @click="removeFile(index)"
                      )
                        | ❌

              // Terms and Conditions
              div.form-check.mt-4
                input.form-check-input(
                  type="checkbox"
                  id="terms"
                  v-model="formData.acceptTerms"
                  :class="{ 'is-invalid': errors.acceptTerms }"
                  required
                )
                label.form-check-label(for="terms")
                  | Ich akzeptiere die&nbsp;
                  a(:href="urls.agb" target="_blank" rel="noopener") Allgemeinen Geschäftsbedingungen
                  |  und die&nbsp;
                  a(:href="urls.datenschutz" target="_blank" rel="noopener") Datenschutzerklärung
                  |  *
                div.invalid-feedback(v-if="errors.acceptTerms")
                  | Sie müssen den Bedingungen zustimmen

              // Buttons
              div.mt-4
                button.mx-3.btn.btn-primary.btn-lg(
                  type="submit"
                  :disabled="submitting"
                )
                  | Registrieren
                button.mx-3.btn.btn-secondary(
                  type="button"
                  @click="$router.push('/anmeldung')"
                  :disabled="submitting"
                )
                  | Zurück zur Anmeldung

          // Success Message - Show only this when successful
          div.card-body(v-if="successMessage && !submitting")
            div.alert.alert-success
              h5 Registrierung erfolgreich!
              p {{ successMessage }}
              p Sie erhalten in Kürze eine E-Mail mit einem Bestätigungslink.

          // Error Message - Show with form
          div.card-body.py-0(v-if="errorMessage && !submitting && !successMessage")
            div.alert.alert-danger
              h5 Fehler bei der Registrierung
              p {{ errorMessage }}
</template>

<script>
import { mapActions } from 'vuex'
import { cmsPage } from '@/cmsPages'

export default {
  name: 'StudentRegistration',
  data () {
    return {
      formData: {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        passwordConfirm: '',
        billingAddress: {
          street: '',
          zip: '',
          city: '',
          country: 'DE'
        },
        deliveryAddress: {
          street: '',
          zip: '',
          city: '',
          country: 'DE'
        },
        acceptTerms: false
      },
      uploadedFiles: [],
      sameAsShipping: true,
      submitting: false,
      errors: {},
      successMessage: '',
      errorMessage: ''
    }
  },
  computed: {
    urls () {
      return {
        agb: cmsPage('agb'),
        datenschutz: cmsPage('datenschutz')
      }
    }
  },
  methods: {
    ...mapActions('orderFormService', ['registerStudent']),
    toggleSameAddress () {
      if (this.sameAsShipping) {
        this.formData.deliveryAddress = {
          street: this.formData.billingAddress.street,
          zip: this.formData.billingAddress.zip,
          city: this.formData.billingAddress.city,
          country: this.formData.billingAddress.country
        }
      }
    },
    handleFileUpload (event) {
      const files = Array.from(event.target.files)
      this.uploadedFiles = []
      this.errors.documents = ''

      for (const file of files) {
        // Check file type
        const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png']
        if (!allowedTypes.includes(file.type)) {
          this.errors.documents = `Datei ${file.name} hat ein ungültiges Format`
          continue
        }

        // Check file size (5MB max)
        if (file.size > 5 * 1024 * 1024) {
          this.errors.documents = `Datei ${file.name} ist zu groß (max. 5MB)`
          continue
        }

        this.uploadedFiles.push(file)
      }
    },
    removeFile (index) {
      this.uploadedFiles.splice(index, 1)
      if (this.uploadedFiles.length === 0) {
        document.getElementById('documents').value = ''
      }
    },
    formatFileSize (bytes) {
      if (bytes < 1024) return bytes + ' B'
      if (bytes < 1024 * 1024) return Math.round(bytes / 1024) + ' KB'
      return (bytes / (1024 * 1024)).toFixed(1) + ' MB'
    },
    fileToBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => {
          // Remove the data:type/mime;base64, prefix
          const base64String = reader.result.split(',')[1]
          resolve(base64String)
        }
        reader.onerror = error => reject(error)
      })
    },
    validateForm () {
      this.errors = {}

      // Required fields
      if (!this.formData.firstName) this.errors.firstName = 'Vorname ist erforderlich'
      if (!this.formData.lastName) this.errors.lastName = 'Nachname ist erforderlich'
      if (!this.formData.email) this.errors.email = 'E-Mail ist erforderlich'
      if (!this.validateEmail(this.formData.email)) this.errors.email = 'Ungültige E-Mail-Adresse'

      // Password validation
      if (!this.formData.password) {
        this.errors.password = 'Passwort ist erforderlich'
      } else if (this.formData.password.length < 8) {
        this.errors.password = 'Passwort muss mindestens 8 Zeichen lang sein'
      }

      if (this.formData.password !== this.formData.passwordConfirm) {
        this.errors.passwordConfirm = 'Passwörter stimmen nicht überein'
      }

      // Address validation
      if (!this.formData.billingAddress.street) this.errors['billingAddress.street'] = 'Straße ist erforderlich'
      if (!this.formData.billingAddress.zip) this.errors['billingAddress.zip'] = 'Postleitzahl ist erforderlich'
      if (!this.formData.billingAddress.city) this.errors['billingAddress.city'] = 'Stadt ist erforderlich'
      if (!this.formData.billingAddress.country) this.errors['billingAddress.country'] = 'Land ist erforderlich'

      // Validate ZIP codes
      if (this.formData.billingAddress.country === 'DE' && !/^\d{5}$/.test(this.formData.billingAddress.zip)) {
        this.errors['billingAddress.zip'] = '5-stellige Postleitzahl erforderlich'
      }
      if (this.formData.billingAddress.country === 'AT' && !/^\d{4}$/.test(this.formData.billingAddress.zip)) {
        this.errors['billingAddress.zip'] = '4-stellige Postleitzahl erforderlich'
      }

      if (!this.sameAsShipping) {
        if (!this.formData.deliveryAddress.street) this.errors['deliveryAddress.street'] = 'Straße ist erforderlich'
        if (!this.formData.deliveryAddress.zip) this.errors['deliveryAddress.zip'] = 'Postleitzahl ist erforderlich'
        if (!this.formData.deliveryAddress.city) this.errors['deliveryAddress.city'] = 'Stadt ist erforderlich'
        if (!this.formData.deliveryAddress.country) this.errors['deliveryAddress.country'] = 'Land ist erforderlich'

        if (this.formData.deliveryAddress.country === 'DE' && !/^\d{5}$/.test(this.formData.deliveryAddress.zip)) {
          this.errors['deliveryAddress.zip'] = '5-stellige Postleitzahl erforderlich'
        }
        if (this.formData.deliveryAddress.country === 'AT' && !/^\d{4}$/.test(this.formData.deliveryAddress.zip)) {
          this.errors['deliveryAddress.zip'] = '4-stellige Postleitzahl erforderlich'
        }
      }

      // Document validation
      if (this.uploadedFiles.length === 0) {
        this.errors.documents = 'Bitte laden Sie mindestens einen Schülerausweis hoch'
      }

      // Terms validation
      if (!this.formData.acceptTerms) {
        this.errors.acceptTerms = 'Sie müssen den Bedingungen zustimmen'
      }

      return Object.keys(this.errors).length === 0
    },
    validateEmail (email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return re.test(email)
    },
    async submitRegistration () {
      if (!this.validateForm()) {
        return
      }

      this.submitting = true
      this.errorMessage = ''
      this.successMessage = ''

      try {
        // Prepare documents array with base64 encoded data
        const documents = []
        for (const file of this.uploadedFiles) {
          const base64Data = await this.fileToBase64(file)
          documents.push({
            filename: file.name,
            mimeType: file.type,
            data: base64Data, // Already base64 without prefix from fileToBase64
            sizeBytes: file.size
          })
        }

        console.log('Documents to send:', documents.length, documents)

        // Prepare the request data
        const requestData = {
          email: this.formData.email,
          password: this.formData.password,
          billingAddress: {
            addressType: 1, // ADDRESS_INVOICE
            name1: this.formData.firstName + ' ' + this.formData.lastName,
            name2: '', // Company name, empty for students
            street: this.formData.billingAddress.street,
            zip: this.formData.billingAddress.zip,
            city: this.formData.billingAddress.city,
            country: this.formData.billingAddress.country
          },
          deliveryAddress: {
            addressType: 2, // ADDRESS_DELIVERY
            name1: this.formData.firstName + ' ' + this.formData.lastName,
            name2: '', // Company name, empty for students
            street: this.sameAsShipping ? this.formData.billingAddress.street : this.formData.deliveryAddress.street,
            zip: this.sameAsShipping ? this.formData.billingAddress.zip : this.formData.deliveryAddress.zip,
            city: this.sameAsShipping ? this.formData.billingAddress.city : this.formData.deliveryAddress.city,
            country: this.sameAsShipping ? this.formData.billingAddress.country : this.formData.deliveryAddress.country
          },
          documentsList: documents // Changed from 'documents' to 'documentsList' for repeated proto field
        }

        console.log('Full request data:', requestData)

        // Submit registration using the store action
        const success = await this.registerStudent(requestData)

        if (success) {
          const response = this.$store.state.orderFormService.latestRequests.registerStudent.response
          console.log('Registration response:', response)

          if (response && response.success) {
            this.successMessage = 'Ihre Registrierung war erfolgreich! Bitte überprüfen Sie Ihre E-Mail für die Bestätigung.'
            // Don't clear form immediately, let user see success message
          } else {
            this.errorMessage = (response && response.message) || 'Ein Fehler ist aufgetreten'
          }
        } else {
          const error = this.$store.state.orderFormService.latestRequests.registerStudent.error
          this.errorMessage = (error && error.message) || 'Ein Fehler ist bei der Registrierung aufgetreten'
        }
      } catch (error) {
        console.error('Registration error:', error)
        this.errorMessage = error.message || 'Ein Fehler ist bei der Registrierung aufgetreten'
      } finally {
        this.submitting = false
      }
    },
    resetForm () {
      this.formData = {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        passwordConfirm: '',
        billingAddress: {
          street: '',
          zip: '',
          city: '',
          country: 'DE'
        },
        deliveryAddress: {
          street: '',
          zip: '',
          city: '',
          country: 'DE'
        },
        acceptTerms: false
      }
      this.uploadedFiles = []
      this.sameAsShipping = true
      this.errors = {}
      this.errorMessage = ''
      this.successMessage = ''
      const fileInput = document.getElementById('documents')
      if (fileInput) {
        fileInput.value = ''
      }
    }
  }
}
</script>

<style scoped>
.submitting-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  font-size: 1.2rem;
  font-weight: 500;
  color: #007bff;
  background: rgba(255, 255, 255, 0.95);
  padding: 1rem 2rem;
  border-radius: 0.25rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.background-login {
  min-height: 100vh;
}

.vertical-center {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
}

.invalid-feedback {
  display: block;
}

.card {
  position: relative;
}
</style>
